import { useEffect } from "react";
import AppAPI from "../api";
import {useTranslation} from "react-i18next";
import {useAppSelector} from "../store";
import i18n from "../../i18n";

export default function useEntities() {
  const { i18n } = useTranslation()
  const lang = i18n.language as "ru" | "en"

  const [getTableData] = AppAPI.useLazyGetTableDataQuery()
  const [getCountries] = AppAPI.useLazyGetCountriesQuery()
  const [getActivities] = AppAPI.useLazyGetActivitiesQuery()

  useEffect(() => {
    getTableData({})
    getCountries(lang)
    getActivities(null)
  }, [getActivities, getCountries, getTableData])
}
